export { default } from '@/components/Navbar'
